import { useEffect, useState } from "react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroBanner from "../components/HeroBanner";
import MovieRow from "../components/MovieRow";

export default function Browse() {
  const [data, setData] = useState(null);
  const [continueWatching, setContinueWatching] = useState([]);
  const [watchlist, setWatchlist] = useState([]);

  useEffect(() => {
    api.get("/home/rows").then((r) => setData(r.data));
    api.get("/continue-watching").then((r) => setContinueWatching(r.data)).catch(() => {});
    api.get("/watchlist").then((r) => setWatchlist(r.data)).catch(() => {});
  }, []);

  if (!data) {
    return (
      <div className="min-h-screen bg-[#050505]">
        <Navbar />
        <div className="pt-32 px-8 space-y-6">
          <div className="skeleton h-[60vh] rounded-2xl" />
          <div className="skeleton h-48 rounded-xl" />
          <div className="skeleton h-48 rounded-xl" />
        </div>
      </div>
    );
  }

  const cwItems = continueWatching
    .map((cw) => {
      const all = [...(data.trending || []), ...(data.tvShows || [])];
      return all.find((x) => x.id === cw.contentId);
    })
    .filter(Boolean);

  return (
    <div className="bg-[#050505] min-h-screen text-white" data-testid="browse-page">
      <Navbar />
      <HeroBanner item={data.hero} />
      <div className="pb-12 -mt-32 relative z-10">
        {cwItems.length > 0 && <MovieRow title="Continue Watching" items={cwItems} />}
        {watchlist.length > 0 && <MovieRow title="My List" items={watchlist} />}
        <MovieRow title="Trending Now" items={data.trending} />
        <MovieRow title="New Releases" items={data.newReleases} />
        <MovieRow title="Popular Movies" items={data.popularMovies} />
        <MovieRow title="TV Shows" items={data.tvShows} type="series" />
        {data.africanMovies?.length > 0 && <MovieRow title="African Movies" items={data.africanMovies} />}
        {data.congoleseEntertainment?.length > 0 && <MovieRow title="Congolese Entertainment" items={data.congoleseEntertainment} />}
        {data.liveTvChannels?.length > 0 && <MovieRow title="Live TV Channels" items={data.liveTvChannels} type="channel" />}
        {data.kidsAndFamily?.length > 0 && <MovieRow title="Kids & Family" items={data.kidsAndFamily} />}
        <MovieRow title="Recommended For You" items={data.recommended} />
      </div>
      <Footer />
    </div>
  );
}
